import { createContext, useContext, useEffect, useState } from "react";
import { LANGS, T } from "@/data/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("sm_lang");
    return LANGS.some((l) => l.code === saved) ? saved : "en";
  });

  useEffect(() => {
    localStorage.setItem("sm_lang", lang);
    const meta = LANGS.find((l) => l.code === lang) || LANGS[0];
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", meta.dir);
  }, [lang]);

  const t = (key) => (T[lang] && T[lang][key]) || T.en[key] || key;

  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) return { lang: "en", setLang: () => {}, t: (k) => (T.en[k] || k), langs: LANGS };
  return ctx;
}
